import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { updateUserProfile, getUserDetails } from "../../actions/userActions";
import Axios from "../../axios/axios";
import imageCompression from "browser-image-compression";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";

const EditCustomer = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [name, setName] = useState("");

  const [email, setEmail] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [address3, setAddress3] = useState("");
  const [address4, setAddress4] = useState("");
  const [phone, setPhone] = useState("");
  const [phone1, setPhone1] = useState("");
  const [id1, setId1] = useState("");
  const [id1Sec, setId1Sec] = useState("");
  const [id1Name, setId1Name] = useState("");
  const [id2, setId2] = useState("");
  const [id2Sec, setId2Sec] = useState("");
  const [id2Name, setId2name] = useState("");
  const [photo, setPhoto] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(null); // track which field
  const [previewPhoto, setPreviewPhoto] = useState("");
  const [customerId, setCustomerId] = useState("");

  useEffect(() => {
    dispatch(getUserDetails(id));
  }, [dispatch]);

  const user = useSelector((state) => state.user);
  const { loading, error, user: user_ } = user;

  console.log(user);

  const submitHandler = (e) => {
    e.preventDefault();

    try {
      dispatch(
        updateUserProfile({
          id: user_._id,
          name,
          email,
          customerId,
          password: phone,
          address1,
          address2,
          address3,
          address4,
          phone,
          phone1,
          id1,
          id1Sec,
          id1Name,
          id2,
          id2Sec,
          id2name: id2Name,
          photo,
        }),
      );
      toast.success("Updated successfully");

      setInterval(() => {
        window.location.href = "/users";
      }, 2000);
    } catch (error) {}
  };

  console.log(user_);

  useEffect(() => {
    setName(user_?.name);
    setEmail(user_?.email);
    setAddress1(user_?.address1);
    setAddress2(user_?.address2);
    setAddress3(user_?.address3);
    setAddress4(user_?.address4);
    setPhone(user_?.phone);
    setPhone1(user_?.phone1);
    setCustomerId(user_?.customerId || "");
    setId1Name(user_?.id1Name);
    setId2name(user_?.id2name);
    setPhoto(user_?.photo);
    setId1(user_?.id1);
    setId2(user_?.id2);
    setId1Sec(user_?.id1Sec);
    setId2Sec(user_?.id2Sec);
  }, [user_]);

  const uploadFileHandler = async (e, val) => {
    const file = e.target.files[0];
    if (!file) return;

    console.log("uploading:", val);

    // ✅ INSTANT PREVIEW (only for customer photo)
    if (val === "photo") {
      const preview = URL.createObjectURL(file);
      setPreviewPhoto(preview);
    }

    let compressedFile = file;

    // ✅ FIX: correct typo maxWidthOrHeight
    if (file.size > 1024 * 1024) {
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };
        compressedFile = await imageCompression(file, options);
      } catch (error) {
        console.error("Compression error:", error);
      }
    }

    const formData = new FormData();
    formData.append("image", compressedFile); // ✅ use compressed file

    setUploading(val); // ✅ track which field is uploading

    try {
      const { data } = await Axios.post("/api/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // ✅ SET CORRECT STATE
      if (val === "id1") setId1(data);
      else if (val === "id2") setId2(data);
      else if (val === "id1Sec") setId1Sec(data);
      else if (val === "id2Sec") setId2Sec(data);
      else if (val === "photo") setPhoto(data);
    } catch (error) {
      console.error("Upload error:", error);
    }

    setUploading(null); // ✅ stop loader
  };

  console.log(user?.photo);
  return (
    <div className="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Edit Customer</h4>
            <form class="forms-sample" onSubmit={submitHandler}>
              <div class="form-group">
                <label for="exampleInputName">
                  Customer Name
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="name"
                  value={name}
                  name="name"
                  required={true}
                />
              </div>

              <div class="form-group">
                <label for="exampleInputPriority4">
                  Mobile Number <span style={{ color: "red" }}>*</span>
                </label>

                <input
                  type="number"
                  className="form-control"
                  placeholder="Phone number"
                  value={phone}
                  required={true}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>
                  Customer ID <span style={{ color: "red" }}>*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  value={customerId}
                  onChange={(e) => setCustomerId(e.target.value.toUpperCase())}
                  required
                />
              </div>

              <div class="form-group">
                <label for="exampleInputName">
                  E mail
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">
                  Place
                  <span style={{ color: "red" }}>*</span>
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Place"
                  value={address1}
                  required={true}
                  onChange={(e) => setAddress1(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Post</label>
                {/* ////////////////////////////////// */}
                <input
                  type="text"
                  className="form-control"
                  placeholder="Post"
                  value={address2}
                  onChange={(e) => setAddress2(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Pin</label>

                <input
                  type="number"
                  className="form-control"
                  placeholder="Pin"
                  value={address3}
                  onChange={(e) => setAddress3(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Area</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Area"
                  value={address4}
                  onChange={(e) => setAddress4(e.target.value)}
                />
              </div>

              <div class="form-group">
                <label for="exampleInputPriority4">Customer Photo</label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo")}
                />
              </div>
              {uploading === "photo" ? (
                <div class="spinner-border" role="status"></div>
              ) : (
                <img
                  src={
                    previewPhoto ||
                    photo ||
                    process.env.PUBLIC_URL + "/images/select_image.png"
                  }
                  height="120"
                  style={{ borderRadius: "8px", marginTop: "10px" }}
                />
              )}

              <div class="form-group">
                <label for="exampleInputPriority4">Alternative number</label>

                <input
                  type="number"
                  className="form-control"
                  placeholder="phone number"
                  value={phone1}
                  onChange={(e) => setPhone1(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Id Proof 1</label>

                <select
                  className="form-control"
                  onChange={(e) => setId1Name(e.target.value)}
                  value={id1Name}
                >
                  <option value="" disabled>
                    Select Aadhar/License
                  </option>
                  <option value="Aadhar">Aadhar</option>
                  <option value="License">License</option>
                  <option value="Passport">Passport</option>
                  <option value="Idproof">ID Proof</option>
                </select>
              </div>

              <div class="form-group">
                <label for="exampleInputPriority4"> </label>
                <b>1.</b>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "id1")}
                  // required={true}
                />
              </div>
              {uploading === "id1" ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    id1 === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${id1}`
                  }
                  height="100"
                />
              )}
              <div class="form-group">
                <label for="exampleInputPriority4"> </label>
                <b>2.</b>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "id1Sec")}
                  // required={true}
                />
              </div>
              {uploading === "id1Sec" ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    id1Sec === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${id1Sec}`
                  }
                  height="100"
                />
              )}
              <div class="form-group">
                <label for="exampleInputPriority4">Id Proof 2</label>

                <select
                  className="form-control"
                  onChange={(e) => setId2name(e.target.value)}
                  value={id2Name}
                >
                  <option value="" disabled>
                    Select Aadhar/License
                  </option>
                  <option value="Aadhar">Aadhar</option>
                  <option value="License">License</option>
                  <option value="Passport">Passport</option>
                  <option value="Idproof">ID Proof</option>
                </select>
              </div>
              <b>1.</b>
              <input
                type="file"
                className="form-control"
                onChange={(e) => uploadFileHandler(e, "id2")}
                // required={true}
              />
              {uploading === "id2" ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    id2 === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${id2}`
                  }
                  height="100"
                />
              )}
              <br />
              <b>2.</b>
              <input
                type="file"
                className="form-control"
                onChange={(e) => uploadFileHandler(e, "id2Sec")}
                // required={true}
              />
              {uploading === "id2Sec" ? (
                <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                <img
                  src={
                    id2Sec === ""
                      ? process.env.PUBLIC_URL + "/images/select_image.png"
                      : `${id2Sec}`
                  }
                  height="100"
                />
              )}

              <br />

              <button type="submit" class="btn btn-primary mr-2">
                Update
              </button>
              <Link to="/users">
                <button class="btn btn-light">Cancel</button>
              </Link>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default EditCustomer;
